import type { AllExtraInfo } from '../../../selectors';
import { normaliseEmail, normalisePhone } from '../helpers';

const getExtraInfo = (state: AllExtraInfo) => {
  if (!state) return {};
  const { noAbn, email, mobile, abn } = state;

  let extraInfoDataPoints;

  extraInfoDataPoints = {
    emailBool: 'false',
    genericDimensionTwo: `no ABN|${noAbn}`,
  };

  // ABN number is given.
  if (!noAbn) {
    extraInfoDataPoints = {
      ...extraInfoDataPoints,
      genericDimensionTwo: abn,
    };
  }

  if (email)
    extraInfoDataPoints = {
      ...extraInfoDataPoints,
      emailHash: normaliseEmail(email),
      emailBool: 'true',
    };

  if (mobile) {
    extraInfoDataPoints = {
      ...extraInfoDataPoints,
      mobileHash: normalisePhone(mobile),
    };
  }
  return extraInfoDataPoints;
};

export default getExtraInfo;
